export const GET_DROPDOWN_VALUES_UK = "GET_DROPDOWN_VALUES_UK";
export const GET_C88_FORM_UK = "GET_C88_FORM_UK";

export const SAVE_C88_FORM_UK = "SAVE_C88_FORM_UK";
export const SAVE_C88_ITEM = "SAVE_C88_ITEM";
export const SAVE_C88_DUTY = "SAVE_C88_DUTY";
export const CLONE_FOR_ALLITEM_C88 = "CLONE_FOR_ALLITEM_C88";

export const DELETE_C88_ENTITY_UK = "DELETE_C88_ENTITY_UK";
export const GET_HS_MASTER_HS = "GET_HS_MASTER_HS";
export const GET_PROCEDURE_CODE_VALUES = "GET_PROCEDURE_CODE_VALUES";
export const GET_SHIPMENT_NOTES = "GET_SHIPMENT_NOTES";
export const SAVE_SHIPMENT_NOTES = "SAVE_SHIPMENT_NOTES";
export const DELETE_SHIPMENT_NOTES = "DELETE_SHIPMENT_NOTES";
export const GET_AI_VALUES = "GET_AI_VALUES";
export const AI_DETAIL_STATEMENT = "AI_DETAIL_STATEMENT";
export const AI_DETAIL_DOCS = "AI_DETAIL_DOCS";
